export default __webpack_public_path__ + "static/media/logo-crowdclass.1fce739d.svg";